import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { ExportDialog, ExportsToTake } from "@amtana/export-client";
import { phrase } from "@amtana/i18n/catalog";

import { EXPORT_CATALOGS } from "./model/export-copy.ts";
import { EXPORT_ERROR_COPY } from "./model/export-error-copy.ts";

export const exportBrowserModule: BrowserModule = defineBrowserModule("export")
  .withErrorCopy(EXPORT_ERROR_COPY)
  .withScreens({
    list: {
      path: "/exports",
      title: phrase(EXPORT_CATALOGS, "exportsScreenTitle"),
      layout: "app",
      load: () => import("./ui/sections/exports-screen.tsx"),
    },
    download: {
      path: "/exports/:exportId/download",
      title: phrase(EXPORT_CATALOGS, "downloadScreenTitle"),
      layout: "app",
      load: () => import("./ui/sections/download-screen.tsx"),
    },
  })
  .withLends([
    { token: ExportDialog, load: () => import("./ui/sections/export-dialog.tsx") },
    { token: ExportsToTake, load: () => import("./ui/sections/exports-to-take.tsx") },
  ]);
